import {
  LOAD_WATCHLIST,
  ADD_TO_WATCHLIST,
  UPDATE_WATCHLIST_ITEM,
  REMOVE_FROM_WATCHLIST,
  BULK_UPDATE_WATCHLIST,
} from "./types";

const initialState = {
  items: {},
  loading: true,
};

export default function watchlistReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_WATCHLIST:
      return { items: action.payload, loading: false };
    case ADD_TO_WATCHLIST:
      return {
        ...state,
        items: { ...state.items, [action.payload.imdbID]: action.payload },
      };
    case UPDATE_WATCHLIST_ITEM:
      return {
        ...state,
        items: { ...state.items, [action.payload.imdbID]: action.payload },
      };
    case BULK_UPDATE_WATCHLIST:
      return {
        ...state,
        items: { ...state.items, ...action.payload },
      };
    case REMOVE_FROM_WATCHLIST: {
      const newItems = { ...state.items };
      delete newItems[action.payload];
      return { ...state, items: newItems };
    }
    default:
      return state;
  }
}
